// LocalUnpublishedPostCard.js
'use strict';
import { connect } from 'react-redux';

import { SHORT_VIDEO_DURATION_SECONDS } from '../RemoteConfigKeys.js';

import UnpublishedPostCard from '../component/UnpublishedPostCard.jsx';

import getAssetAverageProgress from '../selector/getAssetAverageProgress.js';
import getAssetData from '../selector/getAssetData.js';
import getMessageData from '../selector/getMessageData.js';
import getUploadJobStatusI18nKey from '../selector/getUploadJobStatusI18nKey.js';
import getOperationData from '../selector/getOperationData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import toggleModal from '../action/toggleModal.js';
import pauseUploadJobs from '../action/pauseUploadJobs.js';

import { Status as UploadStatus } from '../resource/uploadConstants.js';

const mapStateToProps = (state, { uploadJobId }) => {
  const messageId = getOperationData(
    state,
    ['uploadJob', uploadJobId],
    'messageId'
  );
  const assetIds = getMessageData(state, messageId, 'assetIds') || [];
  const assetId = assetIds[0];
  const aupAssetIds = getMessageData(state, messageId, 'aupAssetIds') || [];
  const uploadJobStatus = getOperationData(
    state,
    ['uploadJob', uploadJobId],
    'status'
  );
  const meUsername = getMeData(state, 'username');
  const isFailed = [
    UploadStatus.UPLOAD_FAILED,
    UploadStatus.PROCESSING_FAILED,
    UploadStatus.REVIEW_FAILED,
    UploadStatus.DELIVERY_FAILED,
    UploadStatus.FAILED,
  ].includes(uploadJobStatus);
  const isReviewing = [
    UploadStatus.REVIEW_STARTED,
    UploadStatus.REVIEW_COMPLETED,
    UploadStatus.DELIVERY_STARTED,
  ].includes(uploadJobStatus);
  const isDeletable = [
    UploadStatus.PENDING,
    UploadStatus.FAILED,
    UploadStatus.UPLOAD_STARTED,
    UploadStatus.UPLOAD_FAILED,
    UploadStatus.PROCESSING_FAILED,
    UploadStatus.REVIEW_FAILED,
  ].includes(uploadJobStatus);
  const isUpload = [UploadStatus.UPLOAD_STARTED].includes(uploadJobStatus);
  return {
    messageId,
    assetId,
    originalTitle: getMessageDataWithVariable(
      state,
      messageId,
      'originalTitle',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    originalCaption: getMessageDataWithVariable(
      state,
      messageId,
      'originalCaptionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    uploadJobStatus: getOperationData(
      state,
      ['uploadJob', uploadJobId],
      'status'
    ),
    uploadJobType: getOperationData(state, ['uploadJob', uploadJobId], 'type'),
    contentType: getAssetData(state, [assetId], 'contentType'),
    statusI18nKey: getUploadJobStatusI18nKey(state, uploadJobId),
    // TODO: adjust performance
    progress: getAssetAverageProgress(state, [...assetIds, ...aupAssetIds]),
    duration: getAssetData(state, [assetId], 'duration'),
    postedAtUnix: getMessageData(state, messageId, 'postedAtUnix'),
    ttl: getMessageData(state, messageId, 'ttl'),
    scheduledAtUnix: getMessageData(state, messageId, 'scheduledAtUnix'),
    shortVideoDuration: getRemoteConfigData(
      state,
      SHORT_VIDEO_DURATION_SECONDS
    ),
    isLocal: true,
    isReviewing,
    isFailed,
    isDeletable,
    isUpload,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: data => dispatch(toggleModal(data)),
    pauseUploadJobs: data => dispatch(pauseUploadJobs(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnpublishedPostCard);
